import { commonConstants } from "../constants";

export function masterData(state = {}, action) {
  let oldstate = state;
  let currentstate = false;

  switch (action.type) {

    case commonConstants.METADATA_SUCCESS:
      currentstate = { metadata: action.payload };
      break;

    case commonConstants.DUMMY_LOADING_REQUEST:
      currentstate = { loading: true };
      break;
    case commonConstants.DUMMY_LOADING_COMPLETE:
      currentstate = { loading: false };
      break;

    default:
      break;
  }

  if (!!currentstate) {
    return { ...oldstate, ...currentstate };
  } else {
    return oldstate;
  }
}
